export interface AppSchedule {
  id: string;
  name: string;
  totalUnits: number;
  description?: string;
}

export interface TokoApp {
  id: string;
  name: string;
  shortName: string;
  icon: string;
  color: string;
  gradientStart: string;
  gradientEnd: string;
  appStoreUrl: string;
  schedules: AppSchedule[];
}

export const TOKO_APPS: TokoApp[] = [
  {
    id: 'addition',
    name: 'TOKO Add',
    shortName: 'Addition',
    icon: '/icons/addition.png',
    color: '#00CEC9',
    gradientStart: '#00d5ee',
    gradientEnd: '#00ffba',
    appStoreUrl: 'https://apps.apple.com/at/app/tokoaddition1/id6756780023?l=en-GB',
    schedules: [
      { id: 'A', name: 'Schedule A', totalUnits: 22, description: 'Standard progression' },
      { id: 'B', name: 'Schedule B', totalUnits: 53, description: 'Extended progression' },
    ],
  },
  {
    id: 'addition-plus',
    name: 'TOKO Add+',
    shortName: 'Add+',
    icon: '/icons/addition-plus.png',
    color: '#00CEC9',
    gradientStart: '#00d5ee',
    gradientEnd: '#00ffba',
    appStoreUrl: '/coming-soon',
    schedules: [
      { id: 'A', name: 'Cascaded', totalUnits: 6, description: 'Multi-digit addition with 3-5 operands' },
    ],
  },
  {
    id: 'multiplication',
    name: 'TOKO Mult',
    shortName: 'Multiplication',
    icon: '/icons/multiplication.png',
    color: '#FF6B00',
    gradientStart: '#ff4f38',
    gradientEnd: '#ff8d12',
    appStoreUrl: '/coming-soon',
    schedules: [
      { id: 'A', name: 'Schedule A', totalUnits: 22, description: 'Standard progression' },
      { id: 'B', name: 'Schedule B', totalUnits: 53, description: 'Extended progression' },
    ],
  },
];

export function getAppById(id: string): TokoApp | undefined {
  return TOKO_APPS.find(app => app.id === id);
}

export function getScheduleForApp(appId: string, scheduleId: string): AppSchedule | undefined {
  const app = getAppById(appId);
  return app?.schedules.find(s => s.id === scheduleId);
}
